import { faEye, faInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { Link, Redirect, useHistory, useLocation } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import Header from "../../../components/Header";
import { dateCol } from "../../../components/TableStyle";
import { UserConsumer } from "../../../UserContext";
import FilterationBar from "./FilterationBar";
import PerformanceReportTable from "./PerformanceReportTable";
import { TimesheetPerformanceReport_APIs } from "./TimesheetPerformanceReport_APIs";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../../components/GlobalPaginationSize";
import { APIDateFormat } from "../../Dashboard/DashboardVariables";
import { Routes } from "../../../configurations/config";

function TimesheetPerformanceReport() {
	let token,
		employeeId,
		empDepartment,
		empDesignation = null;
	const history = useHistory();
	const location = useLocation();

	// Redirection from Timesheet Performance Reprot SP Dashboard
	let monthTPRRedirection = location?.state?.monthTPRRedirection;
	let weekTPRredirection = location?.state?.weekTPRredirection;

	const startDateRedirectedFormat = monthTPRRedirection
		? moment(monthTPRRedirection).format("DD/MM/YYYY")
		: weekTPRredirection
		? moment(new Date(weekTPRredirection)).format("DD/MM/YYYY")
		: null;
	const endDateRedirectedFormat = monthTPRRedirection
		? moment(new Date(startDateRedirectedFormat)).endOf("month")
		: weekTPRredirection
		? moment(new Date(weekTPRredirection)).format("DD/MM/YYYY")
		: null;
	const defaultSorted = [
		{
			dataField: "employeeName",
			order: "asc",
		},
	];
	const scoreList = [
		{ value: 0, label: "All" },
		{ value: 1, label: "1 - Failed to Meet Expectations" },
		{ value: 2, label: "2 - Meeting Expectations -" },
		{ value: 3, label: "3 - Meeting Expectations" },
		{ value: 4, label: "4 - Meeting Expectations +" },
		{ value: 5, label: "5 - Meeting and Exceeding Expectations" },
		{ value: -1, label: "None" },
	];
	const columns = [
		{
			dataField: "employeeName",
			text: "Employee Name",
			sort: true,
			headerStyle: { minWidth: "150px" },
		},
		{
			dataField: "supervisorName",
			text: "Supervisor Name",
			sort: true,
			headerStyle: { minWidth: "150px" },
		},
		{
			dataField: "weekStartDate",
			text: "Week Start Date",
			sort: true,
			formatter: dateCol,
			headerStyle: { minWidth: "150px" },
		},
		{
			dataField: "weekEndDate",
			text: "Week End Date",
			sort: true,
			formatter: dateCol,
			headerStyle: { minWidth: "150px" },
		},
		{
			dataField: "submittedDate",
			text: "Submittted Date",
			sort: true,
			formatter: (cell) => {
				return cell ? dateCol(cell) : "";
			},
		},
		{
			dataField: "status",
			text: "Status",
			sort: true,
		},
		{
			dataField: "score",
			text: "Score",
			headerStyle: { minWidth: "120px" },
			headerFormatter: () => {
				return (
					<>
						<span>{"Score"}</span>
						<span data-tip="tooltip" data-for="scoreInfo">
							<FontAwesomeIcon
								icon={faInfo}
								className="fas fa-info-circle scoreInfo-icon mt-2"
							/>
						</span>
						<ReactTooltip
							id="scoreInfo"
							className="ScoreInfoToolTip"
							place="bottom"
							effect="solid"
							variant="light"
							positionStrategy="fixed"
						>
							{"Scores are calculated on Following criteria:\n" +
								"5- MEE : If submission date is less than or equal to weekend date\n" +
								"4- ME+: If submissiond date is one day greater than weekend date\n" +
								"3- ME: If submissiond date is two days greater than weekend date\n" +
								"2- ME-: If submissiond date is three days greater than weekend date\n" +
								"1- FME-: If submissiond date is four or more days greater than weekend date\n"}
						</ReactTooltip>
					</>
				);
			},
			sort: true,
			formatter: (row, cell) => {
				return cell.numericScore === -1
					? " (" + cell.score + ")"
					: cell.numericScore + " (" + cell.score + ")";
			},
		},
		{
			dataField: "approvedByName",
			text: "Approved By",
			sort: true,
		},
		{
			dataField: "approvedDate",
			text: "Approved Date",
			sort: true,
			formatter: (cell) => {
				return cell ? dateCol(cell) : "";
			},
		},
		{
			dataField: "rejectionCount",
			text: "Rejection Count",
			sort: true,
		},
		{
			dataField: "supervisorScore",
			text: "Supervisor's Score",
			headerFormatter: () => {
				return (
					<>
						<span>{"Supervisor's Score"}</span>
						<span data-tip="tooltip" data-for="spScoreInfo">
							<FontAwesomeIcon
								icon={faInfo}
								className="fas fa-info-circle scoreInfo-icon mt-2"
							/>
						</span>
						<ReactTooltip
							id="spScoreInfo"
							className="ScoreInfoToolTip"
							place="bottom"
							effect="solid"
							variant="light"
							positionStrategy="fixed"
						>
							{"Scores are calculated on Following criteria:\n" +
								"5- MEE : If Supervisor's action date is less than or equal to submitted date\n" +
								"4- ME+: If Supervisor's action is one day greater than submitted date\n" +
								"3- ME: If Supervisor's action is two days greater than submitted date\n" +
								"2- ME-: If Supervisor's action is three days greater than submitted date\n" +
								"1- FME-: If Supervisor's action is fours or more days greater than submitted date\n"}
						</ReactTooltip>
					</>
				);
			},
			sort: true,
			formatter: (row, cell) => {
				return cell.supervisorScoreNumeric === -1
					? " (" + cell.supervisorScore + ")"
					: cell.supervisorScoreNumeric +
							" (" +
							cell.supervisorScore +
							")";
			},
		},
		{
			dataField: "action",
			text: "Action",
			formatter: (cell, row) => {
				return (
					<Link
						to={{
							pathname: Routes.SpTimesheetStatus,
							search: `?week=${moment(row.weekStartDate).format(
								APIDateFormat
							)}&emp=${row.employeeId}`,
						}}
						target="_blank"
					>
						<button className="btnStyle" title="View Detail">
							<FontAwesomeIcon
								id="edit"
								className="hoverEffect"
								icon={faEye}
								size="1x"
							/>
						</button>
					</Link>
				);
			},
		},
	];
	let currentDate = new Date();
	const [startDate, setStartDate] = useState(
		monthTPRRedirection || weekTPRredirection
			? new Date(startDateRedirectedFormat)
			: new Date(moment(currentDate).subtract(1, "weeks"))
	);
	const [endDate, setEndDate] = useState(
		monthTPRRedirection || weekTPRredirection
			? new Date(endDateRedirectedFormat)
			: currentDate
	);

	const [employeeList, setEmployeeList] = useState([]);
	const [selectedEmployee, setSelectedEmployee] = useState(null);
	const [statusList, setStatusList] = useState(null);
	const [selectedStatus, setSelectedStatus] = useState(null);
	const [selectedScore, setSelectedScore] = useState(null);
	const [averageScrore, setAverageScore] = useState(null);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [apiHeaderToken, setApiHeaderToken] = useState(null);
	const [pagerData, setPagerData] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [tableData, setTableData] = useState([]);
	const [flag, setFlag] = useState(false);
	const [showBtnLoading, setShowBtnLoading] = useState(false);
	const [pageNum, setPageNum] = useState(1);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.defaultPaginationSize
	);

	useEffect(() => {
		getStatusList();
		let UrlParams = new URLSearchParams(window.location.search);
		const empId = UrlParams.get("emp");

		if (empId) {
			let empName = history.location.state?.empName;
			let score = history.location.state?.score;

			setSelectedScore(scoreList.find((item) => item.value === score));
			getPerformanceReport(empId, empName, score);
			getEmployeeList(empId, empName);
		} else {
			getEmployeeList();
			getPerformanceReport();
			setSelectedScore(scoreList[0]);
		}
	}, []);

	const getEmployeeList = (empId, empName) => {
		if (
			empDepartment === "5" || //Accounts
			empDepartment === "9" || //Admin
			empDesignation?.toString() === "4" || //CM
			employeeId?.toString() === "180" || //Abdullah
			employeeId?.toString() === "42" || //Umer khan
			employeeId?.toString() == "232" /*Moazzam*/
		) {
			axios
				.get(`${TimesheetPerformanceReport_APIs.GetEmployeeList}`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ data }) => {
					const empList = data;
					empList.sort((a, b) => a.name.localeCompare(b.name));
					let list = empList.map((item) => {
						return { value: item.employeeId, label: item.name };
					});
					let allEmp = { value: 0, label: "All" };
					list.unshift(allEmp);
					if (empId)
						setSelectedEmployee({ value: empId, label: empName });
					else setSelectedEmployee(allEmp);
					setEmployeeList(list);
				});
		} else {
			axios
				.get(
					`${TimesheetPerformanceReport_APIs.GetSupervisorsEmployeesList}`,
					{
						headers: { Authorization: `Bearer ${token}` },
					}
				)
				.then(({ data }) => {
					const empList = data;
					empList.sort((a, b) => a.name.localeCompare(b.name));
					let list = empList.map((item) => {
						return { value: item.employeeId, label: item.name };
					});
					let allEmp = { value: 0, label: "All" };
					list.unshift(allEmp);
					setSelectedEmployee(allEmp);
					setEmployeeList(list);
				});
		}
		setApiHeaderToken({ Authorization: `Bearer ${token}` });
	};
	const getStatusList = () => {
		axios
			.get(`${TimesheetPerformanceReport_APIs.GetStatusTypes}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(({ data }) => {
				let list = data.myTimesheetStatusTypes;
				let newArray = list.filter(
					(item) =>
						item.label != "Not Created" &&
						item.label != "Saved" &&
						item.label != "In Progress"
				);
				newArray.unshift({ value: 0, label: "All" });
				setStatusList(
					newArray.sort((a, b) => a.label.localeCompare(b.label))
				);
				setSelectedStatus({ value: 0, label: "All" });
			});
	};

	const getPerformanceReport = (empId, empName, score) => {
		const pageSize = getPaginationSizeOnRole(empDesignation);
		setNumberOfItemsPerPage(pageSize);

		setIsLoading(true);
		if (empId) {
			setSelectedEmployee({
				value: empId,
				label: empName,
			});
			let month = history.location.state.month;
			let year = history.location.state.year;
			let startDate = null;
			let NewendDate = null;

			if (month.label === "All") {
				if (year.value != currentDate.getFullYear()) {
					let date1 =
						year.value +
						"-" +
						`${month.value === 0 ? 1 : month.value}` +
						"-1";
					let date2 =
						year.value +
						"-" +
						`${month.value === 0 ? 1 : month.value}` +
						"-31";
					startDate = moment(date1).toDate();
					setStartDate(moment(date1).toDate());
					NewendDate = moment(date2).toDate();
					setEndDate(moment(date2).toDate());
				} else {
					startDate = new Date(moment(currentDate).startOf("year"));
					setStartDate(new Date(moment(currentDate).startOf("year")));
				}
			} else {
				if (year.value != currentDate.getFullYear()) {
					startDate = moment(
						year.label + "-" + month.value + "-1"
					).toDate();
					setStartDate(
						moment(year.label + "-" + month.value + "-1").toDate()
					);
				} else {
					startDate = moment(
						currentDate.getFullYear() + "-" + month.value + "-1"
					).toDate();
					setStartDate(
						moment(
							currentDate.getFullYear() + "-" + month.value + "-1"
						).toDate()
					);
				}
			}

			axios
				.get(
					`${
						TimesheetPerformanceReport_APIs.GetPerformanceReport
					}?PageNumber=${1}&PageSize=${pageSize}&SortBy=${
						sortBy.dataField
					}_${sortBy.order}&Status=${
						selectedStatus ? selectedStatus.value : 0
					}&EmployeeId=${empId}&Score=${score}&StartDate=${moment(
						startDate
					).format(APIDateFormat)}&EndDate=${moment(
						NewendDate || endDate
					).format(APIDateFormat)}`,
					{
						headers: { Authorization: `Bearer ${token}` },
					}
				)
				.then((res) => {
					setIsLoading(false);
					if (res.status === 200) {
						setFlag(true);
						setPageNum(1);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setAverageScore(
							calculateAverageScore(
								res.data.numericAverageScore,
								res.data.averageScore
							)
						);
						setTableData(res.data.timesheetPerformanceReport);
					}
				});
		} else
			axios
				.get(
					`${
						TimesheetPerformanceReport_APIs.GetPerformanceReport
					}?PageNumber=${1}&PageSize=${pageSize}&SortBy=${
						sortBy.dataField
					}_${sortBy.order}&Status=${
						selectedStatus ? selectedStatus.value : 0
					}&EmployeeId=${
						selectedEmployee ? selectedEmployee.value : 0
					}&Score=${
						selectedScore ? selectedScore.value : 0
					}&StartDate=${moment(startDate).format(
						APIDateFormat
					)}&EndDate=${moment(endDate).format(APIDateFormat)}`,
					{
						headers: { Authorization: `Bearer ${token}` },
					}
				)
				.then((res) => {
					setIsLoading(false);
					if (res.status === 200) {
						setFlag(true);
						setPageNum(1);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setAverageScore(
							calculateAverageScore(
								res.data.numericAverageScore,
								res.data.averageScore
							)
						);
						setTableData(res.data.timesheetPerformanceReport);
					}
				});
	};
	const exportToExcel = (e) => {
		e.preventDefault();
		setShowBtnLoading(true);
		axios({
			url: `${TimesheetPerformanceReport_APIs.ExportToExcel}?EmployeeId=${
				selectedEmployee.value
			}&StartDate=${moment(startDate).format(
				APIDateFormat
			)}&EndDate=${moment(endDate).format(APIDateFormat)}&Score=${
				selectedScore.value
			}&Status=${selectedStatus.value}`,
			method: "GET",
			responseType: "blob",
			headers: apiHeaderToken,
		})
			.then((response) => {
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute(
					"download",
					"Timesheet Performance Report.xlsx"
				);
				document.body.appendChild(link);
				link.click();
				setShowBtnLoading(false);
			})
			.catch(() => {
				setShowBtnLoading(false);
			});
	};
	const receiveData = (PageSize) => {
		//call api on table page size change

		setIsLoading(true);
		axios
			.get(
				`${
					TimesheetPerformanceReport_APIs.GetPerformanceReport
				}?PageNumber=1&PageSize=${PageSize}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}&Status=${selectedStatus.value}&EmployeeId=${
					selectedEmployee.value
				}&Score=${selectedScore.value}&StartDate=${moment(
					startDate
				).format(APIDateFormat)}&EndDate=${moment(endDate).format(
					APIDateFormat
				)}`,
				{
					headers: apiHeaderToken,
				}
			)
			.then((res) => {
				setIsLoading(false);
				if (res.status === 200) {
					setFlag(true);
					setPageNum(1);
					setNumberOfItemsPerPage(PageSize);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setAverageScore(
						calculateAverageScore(
							res.data.numericAverageScore,
							res.data.averageScore
						)
					);
					setTableData(res.data.timesheetPerformanceReport);
				}
			});
	};
	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		//call api on table sorting and pagination
		setIsLoading(true);
		let getData = false;
		let apiURL = "";

		if (type === "sort") {
			apiURL = `${
				TimesheetPerformanceReport_APIs.GetPerformanceReport
			}?PageNumber=${page}&PageSize=${numberOfItemsPerPage}&SortBy=${sortField}_${sortOrder}&Status=${
				selectedStatus.value
			}&EmployeeId=${selectedEmployee.value}&Score=${
				selectedScore.value
			}&StartDate=${moment(startDate).format(
				APIDateFormat
			)}&EndDate=${moment(endDate).format(APIDateFormat)}`;
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${
				TimesheetPerformanceReport_APIs.GetPerformanceReport
			}?PageNumber=${page}&PageSize=${numberOfItemsPerPage}&SortBy=${
				sortBy.dataField
			}_${sortBy.order}&Status=${selectedStatus.value}&EmployeeId=${
				selectedEmployee.value
			}&Score=${selectedScore.value}&StartDate=${moment(startDate).format(
				APIDateFormat
			)}&EndDate=${moment(endDate).format(APIDateFormat)}`;
			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: apiHeaderToken,
				})
				.then((res) => {
					setIsLoading(false);
					if (res.status === 200) {
						setFlag(true);
						setPageNum(page);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setAverageScore(
							calculateAverageScore(
								res.data.numericAverageScore,
								res.data.averageScore
							)
						);
						setTableData(res.data.timesheetPerformanceReport);
					}
				});
		}
	};
	const calculateAverageScore = (numericAverageScore, averageScore) => {
		if (numericAverageScore != -1)
			return `${numericAverageScore}
		${averageScore != "" ? " (" + averageScore + ")" : ""}`;
		else return "N/A";
	};
	const handleSubmit = (e) => {
		e.preventDefault();
		getPerformanceReport();
	};
	const rowEvents = {
		onClick: (e, row) => {
			window.open(
				`${Routes.SpTimesheetStatus}?week=${moment(
					row.weekStartDate
				).format(APIDateFormat)}&emp=${row.employeeId}`,
				"_blank"
			);
		},
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empDesignation = userDetails.designation;
				empDepartment = userDetails.department;
				employeeId = userDetails.id;
				return userDetails.empRole.includes("2") || //supervisor
					userDetails.designation.toString() === "4" || //CM
					userDetails.department.includes("5") || //Accounts
					userDetails.empRole.includes("3") || //Admin
					userDetails.id.toString() === "42" || //Umer Khan
					userDetails.id.toString() == "232" /*Moazzam*/ ? (
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header
								title="Timesheet Performance Report"
								headerBorder={true}
							/>
							<FilterationBar
								employeeList={employeeList}
								selectedEmployee={selectedEmployee}
								onEmployeeChange={(obj) =>
									setSelectedEmployee(obj)
								}
								statusList={statusList}
								selectedStatus={selectedStatus}
								onStatusChange={(obj) => setSelectedStatus(obj)}
								scoreList={scoreList}
								selectedScore={selectedScore}
								onScoreChange={(obj) => setSelectedScore(obj)}
								startDate={startDate}
								endDate={endDate}
								onStartDateChange={(startDate) => {
									setStartDate(startDate);
								}}
								onEndDateChange={(endDate) => {
									setEndDate(endDate);
								}}
								handleSubmit={handleSubmit}
								exportToExcel={exportToExcel}
								showBtnLoading={showBtnLoading}
								isTableData={tableData.length}
							/>
							<PerformanceReportTable
								columns={columns}
								defaultSorted={defaultSorted}
								handleTableChange={handleTableChange}
								pagerData={pagerData}
								tableData={tableData}
								receiveData={(PageSize) => {
									receiveData(PageSize);
								}}
								pageNum={pageNum}
								numberOfItemsPerPage={numberOfItemsPerPage}
								loading={isLoading}
								flag={flag}
								averageScrore={averageScrore}
								rowEvents={rowEvents}
							/>
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}

export default TimesheetPerformanceReport;
